
import { mapGetters, mapState } from 'vuex'
import DataTable from '@/mixins/dataTable'
export default {
    mixins: [DataTable],
    props: {
        filter: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            tab: null,
            tabModel: 1,
            api: 'themes/refer-friend/getReferFriend',
            sortBy: 'claim_time|desc',
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
        ...mapGetters({
            referFriend: 'themes/refer-friend/referFriend',
        }),
        headers() {
            return [
                { text: this.tl('claimDateTime'), value: 'claim_time' },
                { text: this.tl('numberOfFriends'), value: 'number_of_friend' },
                { text: this.tl('referralRate'), value: 'max_percentage' },
                { text: this.tl('commission'), value: 'commission' },
                { text: this.tl('status'), value: 'status', sortable: false },
            ]
        },
        pageFriendSummary() {
            let sum = 0
            for (const refer of this.referFriend?.data) {
                if (isNaN(refer.number_of_friend)) continue
                sum += Number.parseInt(refer.number_of_friend)
            }
            return sum
        },
        pageCommissionSummary() {
            let sum = 0
            for (const refer of this.referFriend?.data) {
                if (isNaN(refer.commission)) continue
                sum += Number.parseFloat(refer.commission)
            }
            return sum
        },
    },
    watch: {
        filter: {
            deep: true,
            handler(v) {
                this.customFilters = {
                    ...this.customFilters,
                    ...this.filter,
                }
            },
        },
    },
    mounted() {
        this.customFilters = {
            language: this.handleCookie('wl_locale'),
            start_date: this.$dayjs().format('YYYY-MM-DD'),
            end_date: this.$dayjs().format('YYYY-MM-DD'),
        }
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        sumField(data, key) {
            if (data?.data?.length > 0) {
                return data.data.reduce(
                    (a, b) => parseFloat(a) + (parseFloat(b[key]) || 0),
                    0
                )
            } else {
                return 0
            }
        },
    },
}
